import script from "./SignUpForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpForm.vue?vue&type=script&setup=true&lang=ts"

import "./SignUpForm.vue?vue&type=style&index=0&id=38333929&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38333929"]])

export default __exports__